const devicevideoplayerEls = document.querySelectorAll(
	'[data-js=videoindevice]'
);
for (let i = devicevideoplayerEls.length - 1; i >= 0; i -= 1) {
	const deviceVideoPlayer = devicevideoplayerEls[i];
	const deviceVideo = deviceVideoPlayer.querySelector('video');
	const deviceControls = deviceVideoPlayer.querySelector(
		'.videoplayer-controls'
	);
	const deviceBigButton = deviceControls.querySelector(
		'.videoindevice-play-large'
	);
	const deviceVideoCornerControls = deviceControls.querySelector(
		'.videoindevice-corner-controls'
	);

	const handleFirstPlay = () => {
		deviceVideo.play();
		deviceBigButton.setAttribute('hidden', true);
		deviceVideoCornerControls.removeAttribute('hidden');
		deviceBigButton.removeEventListener('click', handleFirstPlay);
	};

	deviceBigButton.addEventListener('click', handleFirstPlay);

	new IntersectionObserver(
		(entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					handleFirstPlay();
					observer.unobserve(entry.target);
				}
			});
		},
		{
			threshold: 1,
		}
	).observe(devicevideoplayerEls[i]);
}
